import React from 'react';
import { Box, Container, Grid, Typography, Link } from '@mui/material';

const footerLinks: Record<string, string[]> = {
  Services: ['Supply Chain Strategy', 'Transportation Optimization', 'Risk Management'],
  Industries: ['Maritime', 'Air Cargo', 'Trucking'],
  'Digital Insights': ['Logistics Tech', 'Data Analytics'],
  Locations: ['New York','Germany','Italy','Saudi Arabia'],
  About: ['Company Overview', 'Contact'],
};

export const Footer: React.FC = () => (
  <Box sx={{ backgroundColor: '#002b54', color: '#fff', pt: 8, pb: 4 }}>
    <Container maxWidth="lg">
      <Grid 
        container 
        spacing={{ xs: 4, xl: 12 }} // wider gap for xl only
      >
        {Object.entries(footerLinks).map(([section, links]) => (
          <Grid
            {...({ item: true, xs: 12, sm: 6, md: 3 } as any)}
            key={section}
            sx={{ 
              px: { xs: 1, sm: 2, xl: 6 },  // more side padding for xl only
              mb: { xs: 3, sm: 0 } 
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
              color="#b0b0b0"
              sx={{ fontWeight: 600, fontSize: { xs: '1rem', sm: '1.125rem' } }}
            >
              {section}
            </Typography>
            {links.map((text) => (
              <Link
                href="#"
                key={text}
                underline="none"
                color="inherit"
                display="block"
                sx={{
                  py: 0.5,
                  fontSize: { xs: '0.875rem', sm: '1rem' },
                }}
              >
                {text}
              </Link>
            ))}
          </Grid>
        ))}
      </Grid>
      <Box sx={{ textAlign: 'center', mt: 6 }}>
        <Typography variant="body2" color="#b0b0b0">
          © 2025 SyncLogistic. All rights reserved.
        </Typography>
      </Box>
    </Container>
  </Box>
);

export default Footer;
